import { useId } from 'react';
import { Modal } from './Modal';

/** A small success card (for example after removing an employee from the batch). */
export function ResultDialog({ title, body, buttonLabel, onClose }: { title: string; body: string; buttonLabel: string; onClose: () => void }) {
  const titleId = useId();
  const bodyId = useId();
  return (
    <Modal titleId={titleId} describedById={bodyId} onClose={onClose} showClose={false}>
      <div className="wc-modal__icon wc-modal__icon--ok" aria-hidden="true">✓</div>
      <h3 id={titleId} className="wc-modal__title wc-modal__title--center">{title}</h3>
      <p id={bodyId} className="wc-modal__text-center">{body}</p>
      <div className="wc-modal__actions wc-modal__actions--center">
        <button type="button" className="wc-btn wc-btn--primary" onClick={onClose} data-autofocus>{buttonLabel}</button>
      </div>
    </Modal>
  );
}
